module.exports = __webpack_public_path__ + "img/xiaozi_yixiubao.9d8c43b8.png";